module.exports = (s) => {
  return [
    {
      name: '渠道号',
      value: 'channel_alias',
    },
    {
      name: '小游戏appid',
      format: () => {
        return s.micro_app_config.micro_app_id || '-';
      },
    },
    {
      name: '小游戏链接备注',
      format: (row) => {
        const h = s.$createElement;
        return h('div', { class: 'flex' }, [
          h(
            'el-select',
            {
              class: 'mr-10',
              props: {
                size: 'mini',
                value: row.target.value,
                placeholder: '请选择',
              },
              on: {
                change: (value) => {
                  row.target.value = value;
                },
              },
            },
            row.target.options.map(({ label, value }) => {
              return h('el-option', { props: { label, value }}, null);
            }),
          ),
        ]);
      },
    },
    {
      name: '小游戏链接',
      format: (row) => {
        const value = row.target.value;
        return value ? value.split('#')[1] : '-';
      },
    },
  ];
};
